export const SOME_MUTATION = 'SOME_MUTATION'

export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'

export const CLOSE_SIDEBAR = 'CLOSE_SIDEBAR'

// app 
// export const 



// WEBPACK FOOTER //
// ./src/store/mutation-types.js